/**
 * Created by jonathan.kernick on 14/03/2017.
 */
createjs.Sound.alternateExtensions = ["ogg"];

//createjs.Sound.registerPlugins([createjs.WebAudioPlugin,createjs.HTMLAudioPlugin]);

CC.SoundJs = function() {
    this.muted = false;
    this.paused = false;
    this.blurred = false;
    this.instanceList = [];
};

CC.SoundJs.prototype.addSoundJSON = function (audioData) {
  //  this.audioData = JSON.parse(JSON.stringify(audioData));
    this.audioData = audioData;
    createjs.Sound.on("fileload",function(arg){
        if(this.currentMusic)
        {
            this.playMusic(this.currentMusic,this.currentVolume);
        }
    });
        createjs.Sound.registerSound(this.audioData);
};

CC.SoundJs.prototype.play = function (id, volume, loop) {
    if(id !== undefined){
        var instance = createjs.Sound.play(id, {"loop": ((loop)?-1:0)});
        instance.volume = (volume !== undefined) ? volume : 1;
        instance.id = id;
        this.instanceList.push(instance);

        this.scrubInstances();
        return instance;
    }
};

CC.SoundJs.prototype.scrubInstances = function () {
    var instanceScrubbed = false;
    var i, instance, length = this.instanceList.length;
    for (i = length - 1; i >= 0; --i) {
        instance = this.instanceList[i];
        switch (instance.playState) {
            case "playFinished":
            case "playFailed":
                this.instanceList.splice(i, 1);
                break;
        }
    }
    for(var key in createjs.Sound.activePlugin._soundInstances)
    {
        createjs.Sound.activePlugin._soundInstances[key]
        var i, instance, length = createjs.Sound.activePlugin._soundInstances[key].length;
        for (i = length - 1; i >= 0; --i) {
            instance = createjs.Sound.activePlugin._soundInstances[key][i];
            switch (instance.playState) {
                case "playFinished":
                case "playFailed":
                    createjs.Sound.activePlugin._soundInstances[key].splice(i, 1);
                    break;
            }
        }
    }
};

CC.SoundJs.prototype.playMusic = function (id, volume) {
    this.stop(this.currentMusic);
    this.currentMusic = id;
    this.currentVolume = volume || 1;
    if(!this.musicMuted)
    {
        this.play(this.currentMusic,volume,true);
    }
};

CC.SoundJs.prototype.muteMusic = function () {
    this.stop(this.currentMusic);
    this.musicMuted = true;
};

CC.SoundJs.prototype.unmuteMusic = function () {
    this.musicMuted = false;
    if(this.currentMusic)
    {
        this.play(this.currentMusic,this.currentVolume,true);
    }
};

CC.SoundJs.prototype.stopMusic = function () {
    this.stop(this.currentMusic);
    this.currentMusic = undefined;
    this.currentVolume = 1;
};

CC.SoundJs.prototype.stop = function (id) {
    //console.log("stop: " + id)
    var i,instance, length = this.instanceList.length;
    for (i = length-1; i >= 0; --i) {
        instance = this.instanceList[i];
        //   console.log("stopping : " + instance.id + " : " + id);
        if(instance.id === id)
        {
            instance.stop();
            this.instanceList.splice(i,1);
        }
    }
};

CC.SoundJs.prototype.stopAll = function (omit) {
    //console.log("stop all")
    var i,instance, length = this.instanceList.length;
    for (i = length-1; i >= 0; --i) {
        instance = this.instanceList[i];
        // console.log(instance.id);
        if(instance.id !== omit)
        {
            instance.stop();
            this.instanceList.splice(i,1);
        }
    }
};

CC.SoundJs.prototype.stopAllHard = function () {
    this.stopAll();
    createjs.Sound.stop();
};

CC.SoundJs.prototype.removeSounds = function () {
    //console.log("removing Sounds");
  //  createjs.Sound.removeAllSounds();
};

CC.SoundJs.prototype.purge = function () {
    createjs.Sound.removeAllSounds();
};

CC.SoundJs.prototype.mute = function (mute) {
 //   console.log("muted : " + mute);
    this.muted = mute;
    createjs.Sound.muted = this.paused || this.muted || this.blurred;
};

CC.SoundJs.prototype.pause = function (pause) {
 //   console.log("pause : " + pause);
    this.paused = pause;
    createjs.Sound.muted = this.paused || this.muted || this.blurred;
};

CC.SoundJs.prototype.blur = function (blur) {
    //   console.log("pause : " + pause);
    this.blurred = blur;
    createjs.Sound.muted = this.paused || this.muted || this.blurred;
};